var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.data && _vm.data.length
    ? _c("div", { staticClass: "bio" }, [
        _c("div", { staticClass: "bio__section" }, [
          _c(
            "div",
            { staticClass: "row" },
            _vm._l(_vm.data, function (item, i) {
              return _c(
                "div",
                {
                  key: i,
                  staticClass:
                    "bio__card col-default-4 col-v-tablet-6 col-mobile-12",
                },
                [
                  _c(
                    "a",
                    {
                      staticClass: "bio-item",
                      attrs: { href: _vm.buildDetailUrl(item.code) },
                    },
                    [
                      _c("div", { staticClass: "bio-item__image" }, [
                        item.previewPicture && item.previewPicture.link
                          ? _c("img", {
                              attrs: {
                                src: item.previewPicture.link,
                                alt: item.previewPicture.name,
                              },
                            })
                          : _c("img", {
                              attrs: {
                                src: "/images/biographies/imageholder.svg",
                              },
                            }),
                      ]),
                      _vm._v(" "),
                      item.name
                        ? _c("div", {
                            staticClass: "bio-item__name",
                            domProps: { innerHTML: _vm._s(item.name) },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      item.position.value
                        ? _c("div", {
                            staticClass: "bio-item__position",
                            domProps: {
                              innerHTML: _vm._s(item.position.value),
                            },
                          })
                        : _vm._e(),
                    ]
                  ),
                ]
              )
            }),
            0
          ),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }